import ReactQueryProvider from './ReactQueryProvider';

export default ReactQueryProvider;
